module.exports = "/build/web/svg/chevron-blue.a20dd50d15bc5e7ac4648e5998dc2d94.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/chevron-blue.svg
// module id = 89
// module chunks = 24